import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=f040a36a"
import script from "./AppDrawer.vue?vue&type=script&lang=ts"
export * from "./AppDrawer.vue?vue&type=script&lang=ts"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=f040a36a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports